<!-- <div class="bg-card flex min-w-0 flex-auto flex-col dark:bg-transparent sm:absolute sm:inset-0 sm:overflow-hidden"> -->
<!-- Main Content (Table and Paginator) -->
<div class="flex flex-auto flex-col overflow-auto">
  <!-- <ng-container>
    <mat-form-field
      class="fuse-mat-dense fuse-mat-rounded min-w-64 w-80 my-1 mb-3"
      subscriptSizing="dynamic"
    >
      <mat-icon
        class="icon-size-5"
        matPrefix
        svgIcon="heroicons_solid:magnifying-glass"
      ></mat-icon>
      <input
        matInput
        placeholder="Buscar"
        autocomplete="off"
        (input)="onSearchInput($event)"
      />
    </mat-form-field>
  </ng-container> -->
  <!-- Tabla -->
  <div class="container mt-0 flex-auto flex-col">
    <div class="sticky top-0 z-10 bg-gray-100 dark:bg-gray-900">
      <table
        class="w-full table-fixed mat-elevation-z"
        mat-table
        [dataSource]="dataSource"
        matSort
        (matSortChange)="onSortChange($event)"
        matSortDisableClear
        multiTemplateDataRows
      >
        <!--
          <ng-container matColumnDef="det">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <button
              class="h-7 min-h-7 min-w-10 px-2 leading-6"
              (click)="toggleDetails(element)"
              style="margin-left: 10px"
            >
              <mat-icon
                class="icon-size-5"
                [svgIcon]="
                  selectedOrder?._id === element._id
                    ? 'heroicons_solid:chevron-down'
                    : 'heroicons_solid:chevron-up'
                "
              ></mat-icon>
            </button>
          </td>
        </ng-container>

        
        <ng-container matColumnDef="check">
          <th mat-header-cell *matHeaderCellDef class="text-left first-col">
            <mat-checkbox
              color="primary"
              (change)="
                $event ? masterToggle() : null; onCheckboxChange($event)
              "
              [checked]="selection.hasValue() && isAllSelected()"
              [aria-label]="checkboxLabel()"
            >
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col">
            <mat-checkbox
              color="primary"
              (click)="
                $event.stopPropagation(); onCheckboxChange($event, element)
              "
              (change)="$event ? selection.toggle(element) : null"
              [checked]="selection.isSelected(element)"
              [aria-label]="checkboxLabel(element)"
              [disabled]="!validateDataToSynchronize(element)"
            >
            </mat-checkbox>
          </td>
        </ng-container>
      -->

        <ng-container matColumnDef="status">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="text-left first-col table-tittle"
          ></th>
          <td
            mat-cell
            *matCellDef="let element"
            class="text-left first-col table-text"
          >
            <mat-icon
              *ngIf="element.statusId == 0"
              svgIcon="heroicons_solid:x-circle"
              matTooltip="Anulado"
              style="color: rgb(141, 19, 19); cursor: pointer"
            ></mat-icon>
            <mat-icon
              *ngIf="element.statusId == 1"
              svgIcon="heroicons_solid:check-circle"
              matTooltip="Activo"
              style="color: rgb(65, 106, 218); cursor: pointer"
            ></mat-icon>
            <mat-icon
              *ngIf="element.statusId == 6"
              svgIcon="heroicons_solid:play-circle"
              matTooltip="En progreso"
              style="color: rgb(236, 199, 58); cursor: pointer"
            ></mat-icon>
            <mat-icon
              *ngIf="element.statusId == 7"
              svgIcon="heroicons_solid:check-circle"
              matTooltip="Aprobado"
              style="color: rgb(9, 133, 50); cursor: pointer"
            ></mat-icon>
            <mat-icon
              *ngIf="element.statusId == 8"
              svgIcon="heroicons_solid:x-circle"
              matTooltip="Rechazado"
              style="color: rgb(255, 0, 0); cursor: pointer"
            ></mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="statusERP">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="text-left first-col table-tittle"
          ></th>
          <td
            mat-cell
            *matCellDef="let element"
            class="text-left first-col table-text"
          >
            <mat-icon
              *ngIf="element.statusERP == 0 || !element.statusERP"
              svgIcon="heroicons_solid:clock"
              matTooltip="Pendiente envío a ERP"
              style="color: rgb(233, 124, 61); cursor: pointer"
            ></mat-icon>
            <mat-icon
              *ngIf="element.statusERP == 1"
              svgIcon="heroicons_solid:document-arrow-up"
              matTooltip="Enviado a ERP"
              style="color: rgb(65, 106, 218); cursor: pointer"
            ></mat-icon>
            <mat-icon
              *ngIf="element.statusERP == 2"
              svgIcon="heroicons_solid:document-arrow-down"
              matTooltip="Recibido por ERP"
              style="color: rgb(236, 199, 58); cursor: pointer"
            ></mat-icon>
            <mat-icon
              *ngIf="element.statusERP == 3"
              svgIcon="heroicons_solid:document-check"
              matTooltip="Creado en ERP"
              style="color: rgb(9, 133, 50); cursor: pointer"
            ></mat-icon>
            <mat-icon
              *ngIf="element.statusERP == 4"
              svgIcon="heroicons_solid:exclamation-triangle"
              matTooltip="Error enviando a ERP"
              style="color: rgb(141, 19, 19); cursor: pointer"
            ></mat-icon>
            <mat-icon
              *ngIf="element.statusERP == 5"
              svgIcon="heroicons_solid:clock"
              matTooltip="Mod. pendiente de replicar"
              style="color: rgb(148, 46, 139); cursor: pointer"
            ></mat-icon>
            <mat-icon
              *ngIf="element.statusERP == 6"
              svgIcon="heroicons_solid:exclamation-triangle"
              matTooltip="Error en ERP"
              style="color: rgb(255, 0, 0); cursor: pointer"
            ></mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="text-left first-col table-tittle"
          ></th>
          <td
            mat-cell
            *matCellDef="let element"
            class="text-left first-col table-text"
          >
            <span
              *ngIf="element?.subApplication?.code == 'CSMOBILE-BACKOFFICE'"
              style="
                background-color: rgb(40, 101, 141);
                color: white;
                padding: 3px 6px 3px 5px;
                border-radius: 5px;
                margin-left: 7px;
                margin-right: 7px;
                cursor: pointer;
              "
              [matTooltip]="element?.subApplication?.name"
            >
              B
            </span>
            <span
              *ngIf="element?.subApplication?.code == 'CSMOBILE-APP'"
              style="
                background-color: rgb(218, 41, 28);
                color: white;
                padding: 3px 6px 3px 5px;
                border-radius: 5px;
                margin-left: 7px;
                margin-right: 7px;
                cursor: pointer;
              "
              [matTooltip]="element?.subApplication?.name"
            >
              A
            </span>
            <span
              *ngIf="element?.subApplication?.code == 'CSMOBILE-ERP'"
              style="
                background-color: rgb(255, 123, 0);
                color: white;
                padding: 3px 6px 3px 5px;
                border-radius: 5px;
                margin-left: 7px;
                margin-right: 7px;
                cursor: pointer;
              "
              [matTooltip]="'ERP'"
            >
              E
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="soldTo">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="text-left first-col table-tittle"
          >
            Cliente
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="text-left first-col table-text"
          >
            <p class="table-text-m" style="min-width: 102px">
              <span class="table-text-code">{{
                element.soldTo?.externalKeys?.code
              }}</span
              ><br />
              {{ element.soldTo?.name }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="documentNumber">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="text-left first-col table-tittle"
          >
            <span style="text-align: left">Nro. Doc.</span>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="text-left first-col table-text"
          >
            <p class="table-text-m" style="min-width: 55px">
              <span class="table-text-code">
                <b [ngClass]="{ 'underline cursor-pointer': element?.serial }"
                  (click)="element?.serial && goToOrder(element)"
                  [matTooltip]="element?.serial ? 'Ir al pedido' : ''">
                  {{ element?.serial ? element?.serial : '-' }} <mat-icon *ngIf="element?.serial"
                    class="icon-size-3" [svgIcon]="'heroicons_solid:arrow-top-right-on-square'"
                    style="color:rgb(0, 0, 0);"></mat-icon>
                </b>
              </span><br />
              {{ element?.externalKeys?.code }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="class">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="text-left first-col table-tittle"
          >
            Clase
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="text-left first-col table-text"
          >
            <p class="table-text-m">
              @if (element.class) {
                <span
                  class="table-text-code"
                  *ngIf="getCode(element.class) as code"
                >
                  {{ code }} <br />
                </span>
              }
              {{ element?.class?.name }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="text-left first-col table-tittle"
          >
            Fecha
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="text-left first-col table-text"
          >
            <div
              class="table-text-m flex flex-col justify-center"
              style="min-width: 130px"
            >
              <p>
                <b matTooltip="Fecha de carga">Ca: </b>

                {{
                  element?.loadDateTime
                    ? (element?.loadDateTime | date: "dd-MM-yyyy")
                    : "-"
                }}
              </p>

              <p>
                <b matTooltip="Fecha de entrega">E: </b>

                {{
                  element?.deliveryDateTime
                    ? (element?.deliveryDateTime | date: "dd-MM-yyyy")
                    : "-"
                }}
              </p>
              <p>
                <b matTooltip="Fecha de Creacion">Cr: </b>
                {{
                  element?.creationDateTime
                    ? (element?.creationDateTime | date: "dd-MM-yyyy")
                    : "-"
                }}
              </p>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="subTotal">
          <th *matHeaderCellDef class="first-col table-tittle text-right">
            <span class="table-text-m-2">SubTotal</span>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="first-col table-text text-right"
          >
            <p class="table-text-m-2">
              {{ element?.subTotal | decimalFormat }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="surcharge">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="first-col table-tittle text-right"
          >
            <span class="table-text-m-2">Recargo</span>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="first-col table-text text-right"
          >
            <p class="table-text-m-2">
              {{ element?.totalSurcharges | decimalFormat }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="discount">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="first-col table-tittle text-right"
          >
            <span class="table-text-m-2">Descuento</span>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="first-col table-text text-right"
          >
            <p class="table-text-m-2">
              {{ element?.totalDiscounts | decimalFormat }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="tax">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="first-col table-tittle text-right"
          >
            <span class="table-text-m-2">Impuesto</span>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="first-col table-text text-right"
          >
            <p class="table-text-m-2">
              {{ element?.totalTaxes | decimalFormat }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="total">
          <th *matHeaderCellDef class="first-col table-tittle text-right">
            <span class="table-text-m-2">Total</span>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="first-col table-text text-right"
          >
            <p class="table-text-m-2">
              {{ element?.total | decimalFormat }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="creation">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="text-left first-col table-tittle"
          >
            Creación
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="text-left first-col table-text"
          >
            {{ formatDate(element?.creationDateTime, false) }}<br />{{
              formatHour(element?.creationDateTime)
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="loadDateTime">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="text-left first-col table-tittle"
          >
            Carga y<br />Entrega
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="text-left first-col table-text"
          >
            <b>C:</b> {{ formatDate(element?.loadDateTime, false) }}<br />
            <b>E:</b> {{ formatDate(element?.deliveryDateTime, false) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="documentStatus">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="first-col table-tittle text-right"
          >
            Estado<br />Doc.
          </th>
          <td mat-cell *matCellDef="let element" class="first-col text-right">
            {{ "-" }}
          </td>
        </ng-container>

        <!--

            <ng-container matColumnDef="actions">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="text-left first-col"
            style="min-width: 40px"
          >
            <button
              mat-icon-button
              color="primary"
              [matMenuTriggerFor]="filterMenu"
              matTooltip="Sincronizar"
              (click)="synchronizeOrders(null)"
              [disabled]="!isGlobalSynchronizeAvailable"
            >
              <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col">
            <button
              mat-icon-button
              [matMenuTriggerFor]="actionMenu"
              matTooltip="Acciones"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #actionMenu="matMenu">
             
              <button
                mat-menu-item
                (click)="synchronizeOrders(element)"
                [disabled]="!validateDataToSynchronize(element)"
              >
                <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
                <span>Sincronizar</span>
              </button>
              
              <button mat-menu-item (click)="openLogModal(element)">
                <mat-icon>visibility</mat-icon>
                <span>Visualizar logs</span>
              </button>
             
            </mat-menu>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="displayedColumns.length"
          >
            <ng-container
              *ngIf="selectedOrder?._id === element._id"
              class="details-row"
            >
              <ng-container
                *ngTemplateOutlet="
                  rowDetailsTemplate;
                  context: { $implicit: row }
                "
              ></ng-container>
            </ng-container></td
        ></ng-container>
        -->

        <!-- Header Row -->
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns"
          class="sticky top-0 z-10  bg-white dark:bg-gray-900"
        ></tr>
        <!-- Fila principal -->
        <tr
          mat-row
          *matRowDef="let element; columns: displayedColumns"
          class="border-b"
        ></tr>

        <!--   [class.table-expanded-row]="selectedOrder?._id === element._id"
             <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="table-detail-row"
        ></tr>
        
        -->
      </table>
    </div>
    <div
      *ngIf="this.dataSource.data.length === 0"
      class="border-t p-8 text-center text-1xl sm:p-10"
    >
      Lo sentimos, no hay registros para mostrar.
    </div>
  </div>
</div>
<!-- Modales -->
<!-- </div>   -->

<ng-template #noData>
  <span> - </span>
</ng-template>
